import { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';

import Header from '../Header';
import useLocalStorage from '../../hooks/useLocalStorage';
import { ModalContext } from '../../context';

import settings from '../../config';
import { format } from '../../utils';
import editIcon from '../../imgs/edit.png';
import deleteIcon from '../../imgs/delete.png';

const AccessoryInstalments = () => {
  const [accessoryInstalments, setAccessoryInstalments] = useState([]);
  const { accessoriesMerchantId } = useParams();
  const [admin] = useLocalStorage('admin');
  const [, setModal] = useContext(ModalContext);

  useEffect(() => {
    (async () => {
      const response = await axios.post(
        `${settings.api}accessory/instalments`,
        {
          accessoriesMerchantId
        }
      );

      if (response.data.statusCode === 200) {
        setAccessoryInstalments(response.data.data);
      }
    })();
  }, [accessoriesMerchantId]);

  const deleteAccessoryInstalment = async (accessoryInstalmentId) => {
    setModal({
      isModalOpen: true,
      modalAction: async () => {
        const response = await axios.post(
          `${settings.api}accessory/delete-instalment`,
          {
            accessoryInstalmentId
          }
        );

        if (response.data.statusCode === 200) {
          setAccessoryInstalments(
            accessoryInstalments.filter(
              (accessoryInstalment) =>
                accessoryInstalmentId !==
                accessoryInstalment.accessoryInstalmentId
            )
          );
        }
      }
    });
  };

  let totalPaid = 0;

  return (
    <div className='w-full'>
      <Header
        text='اضافه دفعه'
        link={`/accessory/instalments/form/${accessoriesMerchantId}`}
      />
      <table className='w-full table-auto border-separate border-spacing-1 text-right '>
        <thead>
          <tr>
            <th>اسم تاجر الاكسسوار</th>
            <th>المبلغ الاجمالى</th>
            <th>قيمه الدفعه</th>
            <th>خصم</th>
            <th>المبلغ المتبقى</th>
            <th>تاريخ الدفعه</th>
            {admin.canEdit === 1 && <th className='text-center w-24'>تعديل</th>}
            {admin.canDelete === 1 && <th className='text-center w-24'>حذف</th>}
          </tr>
        </thead>
        <tbody>
          {accessoryInstalments.map((accessoryInstalment) => {
            totalPaid +=
              accessoryInstalment.totalPaid + accessoryInstalment.discount;

            return (
              <tr
                key={accessoryInstalment.accessoryInstalmentId}
                className='bg-white odd:bg-gray-100 hover:bg-orange-100'
              >
                <td>{accessoryInstalment.accessoriesMerchantName}</td>
                <td>{format(accessoryInstalment.amount || 0)}</td>
                <td>{format(accessoryInstalment.totalPaid || 0)}</td>
                <td>{format(accessoryInstalment.discount || 0)}</td>
                <td>{format(accessoryInstalment.amount - totalPaid || 0)}</td>
                <td>{accessoryInstalment.instalmentDate}</td>
                {admin.canEdit === 1 && (
                  <td className='text-center'>
                    <Link
                      to={`/accessory/instalments/form/${accessoriesMerchantId}/${accessoryInstalment.accessoryInstalmentId}`}
                    >
                      <img src={editIcon} alt='edit' className='inline h-10' />
                    </Link>
                  </td>
                )}
                {admin.canDelete === 1 && (
                  <td className='text-center'>
                    <div
                      className='flex flex-col items-center w-full cursor-pointer'
                      onClick={() =>
                        deleteAccessoryInstalment(
                          accessoryInstalment.accessoryInstalmentId
                        )
                      }
                    >
                      <img src={deleteIcon} alt='delete' className='h-5' />
                    </div>
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default AccessoryInstalments;
